import { createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0d97626a")

_pushScopeId("data-v-0d97626a")
const _hoisted_1 = { class: "exportPromptContainer" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", null, [
  /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "vpn_key"),
  /*#__PURE__*/_createTextVNode(" License required")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("p", null, " To download project files you are required to have a license key. Saving your projects to the web-editor works without a license key. So you won't lose any progress if you don't have a key yet. ", -1)
const _hoisted_4 = { class: "license-key" }
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode()
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "Remember key", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" To receive a license key please join our "),
  /*#__PURE__*/_createVNode("a", {
    href: "https://discord.gg/ycDG6rS",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "discord"),
  /*#__PURE__*/_createTextVNode(" and use the "),
  /*#__PURE__*/_createVNode("i", null, "#verify-purchase"),
  /*#__PURE__*/_createTextVNode(" channel. The verifcation process is automated and only takes a few seconds. ")
], -1)
const _hoisted_9 = { class: "action-row" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "vpn_key", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "text" }, "Save license key", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "text" }, "Close", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", {
    class: "exportPrompt",
    style: { display: _ctx.licensePromptDoneAction ? 'flex' : 'none' }
  }, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _withDirectives(_createVNode("input", {
          type: "text",
          autocomplete: "off",
          placeholder: "License key",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.licenseKey = $event))
        }, null, 512), [
          [_vModelText, _ctx.licenseKey]
        ]),
        _hoisted_5,
        _withDirectives(_createVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.remember = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.remember]
        ]),
        _hoisted_6,
        _hoisted_7
      ]),
      _hoisted_8,
      _createVNode("div", _hoisted_9, [
        _createVNode("div", {
          class: ["btn export", !_ctx.licenseKey ? 'inactive' : ''],
          onClick: _cache[3] || (_cache[3] = $event => (_ctx.saveKey()))
        }, [
          _hoisted_10,
          _hoisted_11
        ], 2),
        _createVNode("div", {
          class: "btn close",
          onClick: _cache[4] || (_cache[4] = $event => (_ctx.licensePromptDoneAction = null))
        }, [
          _hoisted_12
        ])
      ])
    ])
  ], 4))
})